export default __webpack_public_path__ + "static/media/AnimalsWhite_04.346e437b.png";